import React, { Component } from 'react';
import FormatDate from '../../../utility/FormatDate'


class TabelaAtividades extends Component {

    constructor(props) {
        super(props);
        this.state = {
            data: this.props.listaAtividades
        }
        this.sortColumn = this.sortColumn.bind(this)
    }

    exportCSV(filename) {
        var csv = [];
        var rows = document.querySelectorAll("table#tbl_atividades tr");

        for (var i = 0; i < rows.length; i++) {
            var row = [], cols = rows[i].querySelectorAll("td, th");

            for (var j = 0; j < cols.length; j++)
                row.push(cols[j].innerText);

            csv.push(row.join(";"));
        }

        var d = new Date();
        // Download CSV FILE
        var csvFile = new Blob(["\ufeff", csv.join("\n")], {type: "text/csv"});
        var downloadLink = document.createElement("a");
        downloadLink.download = "lista-atividades_"+filename+"_"+FormatDate.formatISODateTime(d)+".csv";
        downloadLink.href = window.URL.createObjectURL(csvFile);
        downloadLink.style.display = "none";
        document.body.appendChild(downloadLink);
        downloadLink.click();
        downloadLink.remove();
    }

    sortColumn(ev) {
        let th = ev.target;
        if(th.tagName!=="TH") {
            th = ev.target.closest("th");
        }
        let sort = th.querySelector("i.sort");
        let tr = th.closest("tr");
        let orderUp = true;

        let sortNumber = false;
        let sortDate = false;


        // change sort icon
        if(sort.classList.contains('fa-sort')) {
            var sorts = tr.querySelectorAll("i.sort");
            for (var i = 0; i < sorts.length; i++) {
              if(!sorts[i].classList.contains('fa-sort')) {
                  sorts[i].classList.remove('fa-sort-up', 'fa-sort-down');
                  sorts[i].classList.add('fa-sort')
              }
            }
            sort.classList.remove('fa-sort');
            sort.classList.add('fa-sort-up')
        }
        else if(sort.classList.contains('fa-sort-up')) {
            sort.classList.remove('fa-sort-up');
            sort.classList.add('fa-sort-down')
            orderUp = false;
        }
        else if(sort.classList.contains('fa-sort-down')) {
            sort.classList.remove('fa-sort-down');
            sort.classList.add('fa-sort-up')
        }

        if(sort.classList.contains('sort-date')) {
            sortDate = true;
        }
        if(sort.classList.contains('sort-number')) {
            sortNumber = true;
        }

        const sortBy = sort.getAttribute("data-sort");
        const data = this.state.data;

        data.sort((a,b) => {
            // ordenação ascendente
            if(orderUp) {
                if(sortNumber) return (!a[sortBy] || a[sortBy] === '-' ? -1 : a[sortBy]) - (!b[sortBy] || b[sortBy] === '-' ? -1 : b[sortBy]);
                if(sortDate) return (!a[sortBy] || a[sortBy] === '-' ? new Date() : new Date(a[sortBy])) - (!b[sortBy] || b[sortBy] === '-' ? new Date() : new Date(b[sortBy]));
                // sortText
                return a[sortBy].localeCompare(b[sortBy]);
            }
            // ordernação descendente
            if(sortNumber) return (!b[sortBy] || b[sortBy] === '-' ? -1 : b[sortBy]) - (!a[sortBy] || a[sortBy] === '-' ? -1 : a[sortBy]);
            if(sortDate) return (!b[sortBy] || b[sortBy] === '-' ? new Date() : new Date(b[sortBy])) - (!a[sortBy] || a[sortBy] === '-' ? new Date() : new Date(a[sortBy]));
            // sortText
            return b[sortBy].localeCompare(a[sortBy]);
        });

        this.setState({data});
    }

    render() {
        return (<div className={this.props.className? " " + this.props.className:null}>
            <button className="edb-hide-small edb-hide-medium edb-button edb-right edb-padding" title="Exportar tabela em formato CSV" onClick={()=>this.exportCSV(this.props.fileName)}><i className="edb-xlarge fas fa-file-download"></i></button>
            <table id="tbl_atividades" className="edb-table edb-round-large edb-bordered adap-white edb-striped ">
                <thead className="edb-hide-small">
                    <tr>
                        <th width="264" onClick={this.sortColumn}>
                            <div className="edb-cell-row">
                                <div className="edb-cell">
                                    <i className="fa fa-list edb-margin-small-right"></i>
                                </div>
                                <div className="edb-cell">
                                    Atividade <i data-sort="txActivity" className="sort fas fa-sort"></i>
                                </div>
                            </div>
                        </th>
                        <th onClick={this.sortColumn}><i className="far fa-chart-bar edb-margin-small-right"></i> Data de realização <i data-sort="dtStartActivity" className="sort sort-date fas fa-sort-up"></i></th>
                        <th onClick={this.sortColumn}><i className="fas fa-users edb-margin-small-right"></i> Finalizado <i data-sort="txStatusActivity" className="sort fas fa-sort"></i></th>
                    </tr>
                </thead>

                <tbody>
                    {this.state.data && this.state.data.map(
                        (item, index) =>

                            <tr key={`item-atividade-${index}`} >

                                <td className="edb-center edb-block-mobile">
                                    <div className="edb-hide-medium edb-hide-large edb-margin-small-right edb-margin-small-bottom edb-left">
                                        <i className="fa fa-list edb-margin-small-right"></i>
                                        <span className="edb-text-bold"> Atividade</span>
                                    </div>
                                    {/* Sinalizador verde caso simulado em andamento */}
                                    <div className="edb-left-align">
                                        {/* {item.titulo} */}
                                        {item.inActivityType === 1 ?
                                            <button className="edb-btn-link" onClick={()=> this.props.onClickSimulado && this.props.onClickSimulado(item.idExam)}>{item.txActivity}</button>
                                            : <span>{item.txActivity}</span> }
                                    </div>
                                </td>
                                <td className="edb-center  edb-block-mobile">
                                    <div className="edb-hide-medium edb-hide-large edb-margin-small-right edb-margin-small-bottom edb-left">
                                        <i className="far fa-chart-bar edb-margin-small-right"></i>
                                        <span className="edb-text-bold"> Data de realização</span>
                                    </div>
                                    <div className="edb-left-align">
                                        {/* {item.dtRealizacao && item.dtRealizacao.toLocaleDateString()} */}
                                        {item.dtStartActivity && FormatDate.formatDateTime(item.dtStartActivity)}
                                    </div>
                                </td>
                                <td className="edb-center  edb-block-mobile">
                                    <div className="edb-hide-medium edb-hide-large edb-margin-small-right edb-margin-small-bottom edb-left">
                                        <i className="fas fa-tasks edb-margin-small-right"></i>
                                        {/* <span className="edb-text-bold"> Finalizado</span> */}
                                        <span className="edb-text-bold">Status</span>
                                    </div>
                                    <div className="edb-left-align">
                                        {/* {item.finalizado ? "Sim" : "Não"} */}
                                        {item.txStatusActivity}
                                    </div>
                                </td>
                            </tr>
                    )}
                </tbody>
            </table>
        </div>
        );
    }
}

export default TabelaAtividades;